"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "backgroundLiveToggled", {
  enumerable: true,
  get: function get() {
    return _backgroundLiveToggled["default"];
  }
});
var _backgroundLiveToggled = _interopRequireDefault(require("./backgroundLiveToggled"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }